module.exports = __webpack_public_path__ + "static/media/main-tm-background.0ffe3eff.jpg";